export default "__VITE_ASSET__DupVvZgi__"